import styled from 'styled-components';

import { Text } from '@gympass/yoga';

export const Container = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.yoga.spacing.medium}px
    ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  display: flex;
  align-items: center;

  > svg {
    flex: 1 0 auto;
  }
`;

export const NotFoundMessage = styled(Text)`
  margin-left: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
`;
